// prettier-ignore
export const ActionTypes = {
  SHOW_EDIT_MULTIPLE_CHOICE_LOGIC: 'harami/templates/SHOW_EDIT_MULTIPLE_CHOICE_LOGIC',
  SHOW_EDIT_NUMBER_LOGIC: 'harami/templates/SHOW_EDIT_NUMBER_LOGIC',
  CLOSE_EDIT_LOGIC: 'harami/templates/CLOSE_EDIT_LOGIC',
} as const satisfies { [k: string]: string}
